import { render, staticRenderFns } from "./ClaimsStatistics.vue?vue&type=template&id=302d9553&scoped=true&"
import script from "./ClaimsStatistics.vue?vue&type=script&lang=js&"
export * from "./ClaimsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsStatistics.vue?vue&type=style&index=0&id=302d9553&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302d9553",
  null
  
)

export default component.exports